import { render, staticRenderFns } from "./studentInfoCertificationRecord_4.vue?vue&type=template&id=b7805e0e&scoped=true"
import script from "./studentInfoCertificationRecord_4.vue?vue&type=script&lang=js"
export * from "./studentInfoCertificationRecord_4.vue?vue&type=script&lang=js"
import style0 from "./studentInfoCertificationRecord_4.vue?vue&type=style&index=0&id=b7805e0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7805e0e",
  null
  
)

export default component.exports